var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNochat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 82,
    viewBox: "0 0 148 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.413 0H31.5856C27.6815 0 24.5166 2.62233 24.5166 5.85714V76.1429C24.5166 79.3777 27.6815 82 31.5856 82H116.413C120.317 82 123.482 79.3777 123.482 76.1429V5.85714C123.482 2.62233 120.317 0 116.413 0Z",
    fill: "#F7F7F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4705_438591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.67218 9.89648H105.103C106.041 9.89648 106.94 10.2689 107.602 10.9317C108.265 11.5946 108.638 12.4936 108.638 13.431V31.1034C108.638 32.0408 108.265 32.9398 107.602 33.6026C106.94 34.2655 106.041 34.6379 105.103 34.6379H9.67218C8.73477 34.6379 7.83577 34.2655 7.17292 33.6026C6.51008 32.9398 6.1377 32.0408 6.1377 31.1034V13.431C6.1377 12.4936 6.51008 11.5946 7.17292 10.9317C7.83577 10.2689 8.73477 9.89648 9.67218 9.89648Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9141 15.5527H36.5348C35.3635 15.5527 34.4141 16.5022 34.4141 17.6734C34.4141 18.8446 35.3635 19.7941 36.5348 19.7941H54.9141C56.0853 19.7941 57.0348 18.8446 57.0348 17.6734C57.0348 16.5022 56.0853 15.5527 54.9141 15.5527Z",
    fill: "#C6CFD2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6382 24.7422H36.5348C35.3635 24.7422 34.4141 25.6917 34.4141 26.8629C34.4141 28.0341 35.3635 28.9836 36.5348 28.9836H67.6382C68.8094 28.9836 69.7589 28.0341 69.7589 26.8629C69.7589 25.6917 68.8094 24.7422 67.6382 24.7422Z",
    fill: "#F7F7F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5085 28.9857C22.2174 28.9857 25.224 25.9791 25.224 22.2702C25.224 18.5613 22.2174 15.5547 18.5085 15.5547C14.7996 15.5547 11.793 18.5613 11.793 22.2702C11.793 25.9791 14.7996 28.9857 18.5085 28.9857Z",
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9572 26.4259C17.0492 26.4259 17.4622 25.7049 17.4622 24.8509V19.9719H16.7412V24.8509C16.7412 25.3269 16.5242 25.7329 15.9572 25.7329C15.9012 25.7329 15.5862 25.7189 15.4672 25.6769L15.3972 26.3489C15.5792 26.3909 15.8242 26.4259 15.9572 26.4259ZM20.1773 24.8649C21.1503 24.8649 21.8083 24.2279 21.8083 23.4229C21.8083 22.7159 21.2973 22.2749 20.4853 22.0719L19.8763 21.9179C19.2673 21.7639 19.2183 21.4419 19.2183 21.2879C19.2183 20.8469 19.6243 20.5739 20.0793 20.5739C20.5763 20.5739 20.9333 20.8819 20.9333 21.3369H21.6473C21.6473 20.4619 20.9683 19.9159 20.1003 19.9159C19.2463 19.9159 18.4973 20.4549 18.4973 21.3019C18.4973 21.7009 18.6653 22.3099 19.6943 22.5689L20.3103 22.7229C20.7023 22.8279 21.0873 23.0309 21.0873 23.4579C21.0873 23.8569 20.7513 24.2069 20.1773 24.2069C19.5753 24.2069 19.1903 23.8079 19.1763 23.3949H18.4623C18.4623 24.1719 19.1483 24.8649 20.1773 24.8649Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4705_438591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8958 47.3633H138.327C139.264 47.3633 140.163 47.7357 140.826 48.3985C141.489 49.0614 141.861 49.9604 141.861 50.8978V68.5702C141.861 69.5076 141.489 70.4066 140.826 71.0694C140.163 71.7323 139.264 72.1047 138.327 72.1047H42.8958C41.9584 72.1047 41.0594 71.7323 40.3966 71.0694C39.7337 70.4066 39.3613 69.5076 39.3613 68.5702V50.8978C39.3613 49.9604 39.7337 49.0614 40.3966 48.3985C41.0594 47.7357 41.9584 47.3633 42.8958 47.3633V47.3633Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.931 53.0176H89.5514C88.3801 53.0176 87.4307 53.967 87.4307 55.1383C87.4307 56.3095 88.3801 57.259 89.5514 57.259H107.931C109.102 57.259 110.051 56.3095 110.051 55.1383C110.051 53.967 109.102 53.0176 107.931 53.0176Z",
    fill: "#C6CFD2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.93 62.207H76.8267C75.6555 62.207 74.7061 63.1565 74.7061 64.3277C74.7061 65.4989 75.6555 66.4484 76.8267 66.4484H107.93C109.101 66.4484 110.051 65.4989 110.051 64.3277C110.051 63.1565 109.101 62.207 107.93 62.207Z",
    fill: "#F7F7F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.957 66.4486C129.666 66.4486 132.672 63.442 132.672 59.7331C132.672 56.0242 129.666 53.0176 125.957 53.0176C122.248 53.0176 119.241 56.0242 119.241 59.7331C119.241 63.442 122.248 66.4486 125.957 66.4486Z",
    fill: "#D9D9D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.505 58.3681H123.025L124.248 61.3553H124.29L125.513 58.3681H126.034V61.9668H125.626V59.2326H125.591L124.466 61.9668H124.073L122.948 59.2326H122.913V61.9668H122.505V58.3681ZM129.761 58.3681V61.9668H129.339L127.378 59.1412H127.343V61.9668H126.907V58.3681H127.329L129.297 61.2007H129.332V58.3681H129.761Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4705_438591",
    x: 0.137695,
    y: 6.89648,
    width: 114.5,
    height: 36.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4705_438591"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4705_438591",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4705_438591",
    x: 33.3613,
    y: 44.3633,
    width: 114.5,
    height: 36.7422,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4705_438591"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4705_438591",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNochat);
export default __webpack_public_path__ + "static/media/nochat.a42deab004154b72c73f011c3c84428f.svg";
export { ForwardRef as ReactComponent };